import { PLATFORM_MAINTENANCE_ACTIVE, PLATFORM_MAINTENANCE_INACTIVE } from './types';

export const platformMaintenanceActive = () => ({
    type: PLATFORM_MAINTENANCE_ACTIVE
});

export const platformMaintenanceInactive = () => ({
    type: PLATFORM_MAINTENANCE_INACTIVE
});
